export function isArray(o) {
  return Object.prototype.toString.call(o) === '[object Array]'
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function durationTime(submitTime) {
  // 计算当前时间距离待办事项提交时间的时长
  let dateTime = new Date(submitTime)
  let now = new Date()

  let milliseconds = 0
  let timeSpanStr

  milliseconds = now - dateTime
  if (milliseconds <= 1000 * 60 * 60 * 24) {
    timeSpanStr = Math.ceil(milliseconds / (1000 * 60 * 60)) + '小时前'
  } else {
    timeSpanStr = Math.ceil(milliseconds / (1000 * 60 * 60 * 24)) + '天前'
  }
  return timeSpanStr
}


// WEBPACK FOOTER //
// ./src/lib/utils.js